import { BasketItem } from "../../../../models/BasketItem";

export interface SurveyDraft {
  fingerprint: string;
  currentIndex: number;
  allAnswers: Record<string, string>[];
}

const storageKey = (facilityIds: string): string => `basketSurveyDraft:${facilityIds}`;

export const buildSurveyDraftFingerprint = (basket: BasketItem[]): string => {
  return basket
    .filter((item) => item.hasSurvey)
    .map((item) => `${item.assortIds}:${item.qnt}:${item.validFrom ?? ""}`)
    .sort()
    .join("|");
};

export const loadSurveyDraft = (facilityIds: string, fingerprint: string): SurveyDraft | null => {
  if (!fingerprint) return null;

  try {
    const raw = sessionStorage.getItem(storageKey(facilityIds));
    if (!raw) return null;

    const parsed = JSON.parse(raw) as SurveyDraft;
    if (
      parsed?.fingerprint !== fingerprint ||
      !Array.isArray(parsed.allAnswers) ||
      typeof parsed.currentIndex !== "number"
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const saveSurveyDraft = (facilityIds: string, draft: SurveyDraft): void => {
  if (!draft.fingerprint) return;

  try {
    sessionStorage.setItem(storageKey(facilityIds), JSON.stringify(draft));
  } catch {
    // Quota exceeded or private mode — do not block survey UI
  }
};

export const clearSurveyDraft = (facilityIds: string): void => {
  try {
    sessionStorage.removeItem(storageKey(facilityIds));
  } catch {
    // ignore
  }
};
